export default "__VITE_ASSET__cbdbd0c5__"